import React, { Component } from "react";
import { Col, Button, FormGroup, Row, Media, Badge } from "reactstrap";
import { renderGenderPronoun, toolPrivacy } from "../../../../../utils/constants";
import moment from "moment";
// import ToolPlaceholder from '../../../../../components/UI/ToolPlaceholder/ToolPlaceholder';
import ToolPlaceholder from "../../../../../assets/tool-placeholder.png";
import "./HeaderSection.css";
import star from "../../../../../assets/star.svg";
import halfStar from "../../../../../assets/rating-star-half.svg";
import emptyStar from "../../../../../assets/rating-star-grey.svg";
import lockIcon from "../../../../../assets/lock.svg";
import privacyIcon from "../../../../../assets/privacy_icon.svg";
import privacyOfficesBelowIcon from "../../../../../assets/privacy-icon-offices-below.svg";
import privacyEnterprise from "../../../../../assets/privacy_all_enterprise.svg";
import get from "lodash/get";
import { isMobile } from "../../../../../utils/deviceInfo";

export default class Section extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ratingOptions: [1, 2, 3, 4, 5],
    };
  }

  render() {
    let { toolDetails, user, hideRatingsSection } = { ...this.props };
    let { ratings, avgRating } = toolDetails;
    let { ratingOptions } = this.state;
    // console.log(avgRating, ratings)
    avgRating = Math.round(avgRating);

    let privacy = null;
    let createdBy = "";
    let updatedBy = "";
    let toolImage = "";
    let recommendedTagView = null;
    let archivedTagView = null;
    let disableAddRating = false;
    let toolRatings = ratings;
    let userRating =
      ratings && ratings.length > 0
        ? user && user._id? ratings.filter(rating => rating.user && rating.user._id == user._id): ratings
        : [];
    // console.log(ratings)
    if (!ratings) {
      toolRatings = [];
    }
    if (userRating.length > 0) {
      disableAddRating = true;
    }

    // console.log(toolDetails.lastUpdate.user.firstName);
    if (toolDetails) {
      if (toolDetails.imageUrl && toolDetails.imageUrl !== "") {
        toolImage = (
          <div className="tool_details_page_img_div_container">
            <img
              // style={{ objectFit: "cover", height: "100%" }}
              src={toolDetails.imageUrl}
              crossOrigin="Anonymous"
            />
          </div>
        );
      } else {
        if (typeof toolDetails.image === "string" && toolDetails.image !== "") {
          toolImage = (
            <div className="tool_details_page_img_div_container">
              <img
                src={toolDetails.image}
                className="tool_img_obj_fit_container"
                // style={{ objectFit: "cover", height: "100%" }}
                crossOrigin="Anonymous"
              />
            </div>
          );
        } else if (toolDetails.bannerImg && toolDetails.bannerImg.url) {
          let image = toolDetails.bannerImg.url;
          toolImage = (
            <div className="tool_details_page_img_div_container">
              <img
                // style={{ objectFit: "cover", height: "100%" }}
                src={image}
                crossOrigin="Anonymous"
              />
            </div>
          );
        } else {
          toolImage = (
            <div className="tool_details_page_img_div_container">
              <img
                src={ToolPlaceholder}
                className="tool_img_placeholder_container"
                style={{ height: "144px", width: "144px" }}
                crossOrigin="Anonymous"
              />
            </div>
          );
        }
      }
    }
    if (
      !get(toolDetails, "isArchive.value", toolDetails.isArchive) &&
      !toolDetails.isRecommendedByAdmin
    ) {
      if (toolDetails.privacy === toolPrivacy.private) {
        privacy = (
          <span className="ml10">
            <img
              src={lockIcon}
              style={{ height: "25.1px", verticalAlign: "inherit" }}
            />
          </span>
        );
      } else if (toolDetails.privacy === toolPrivacy.office) {
        privacy = (
          <span className="ml10">
            <img
              src={privacyIcon}
              style={{ height: "20px", verticalAlign: "inherit" }}
            />
          </span>
        );
      } else if (toolDetails.privacy === toolPrivacy.officeAndChildren) {
        privacy = (
          <span className="ml10">
            <img
              src={privacyOfficesBelowIcon}
              style={{ height: "20px", verticalAlign: "inherit" }}
            />
          </span>
        );
      } else if (toolDetails.privacy === "ENTERPRISE") {
        privacy = (
          <span className="ml10">
            <img
              src={privacyEnterprise}
              style={{ height: "20px", verticalAlign: "inherit" }}
            />
          </span>
        );
      }
    }

    if (
      toolDetails.isRecommendedByAdmin &&
      !get(toolDetails, "isArchive.value", toolDetails.isArchive)
    ) {
      recommendedTagView = (
        <span>
          <Badge
            className="recommendedTag ml10"
            style={{ verticalAlign: "middle" }}
          >
            <span className="recommendedTagText">Recommended</span>
          </Badge>
        </span>
      );
    }

    if (toolDetails.isArchive && toolDetails.isArchive.value === true) {
      archivedTagView = (
        <span>
          <Badge
            className="archivedTag ml10"
            style={{ verticalAlign: "middle" }}
          >
            <span className="archivedTagText">Archived</span>
          </Badge>
        </span>
      );
    }

    // if (!toolDetails.isRecommendedByAdmin) {
    //   createdBy = `OurOffice on ${moment(toolDetails.createDate).format("MMMM Do, YYYY")}`;
    //   updatedBy = `OurOffice on ${moment(toolDetails.lastUpdate && toolDetails.lastUpdate.updatedData ? (toolDetails.lastUpdate.updatedData.date ? toolDetails.lastUpdate.updatedData.date : new Date()) : new Date()).format("MMMM Do, YYYY")}`;
    // } else {
    if (toolDetails.createdBy) {
      let createdUserFirstName = toolDetails.createdBy
        ? toolDetails.createdBy.firstName
          ? toolDetails.createdBy.firstName
          : ""
        : "";
      let createdUserLastName = toolDetails.createdBy
        ? toolDetails.createdBy.lastName
          ? toolDetails.createdBy.lastName
          : ""
        : "";
      let updatedUserFirstName =
        toolDetails.lastUpdate && toolDetails.lastUpdate.user
          ? toolDetails.lastUpdate.user.firstName
            ? toolDetails.lastUpdate.user.firstName
            : ""
          : "";
      let updatedUserLastName =
        toolDetails.lastUpdate && toolDetails.lastUpdate.user
          ? toolDetails.lastUpdate.user.lastName
            ? toolDetails.lastUpdate.user.lastName
            : ""
          : "";
      createdBy = (
        <span>
          {createdUserFirstName} {createdUserLastName}  <span className="user_gender_pronoun_toolsview">
                        {renderGenderPronoun(toolDetails.createdBy)}
                      </span> 
          <div>on {moment(toolDetails.createDate).format("MMMM Do, YYYY")}</div>
        </span>
      );
      // console.log(createdUserFirstName);
      if (
        toolDetails.lastUpdate &&
        toolDetails.lastUpdate.updatedData &&
        toolDetails.lastUpdate.updatedData.date
      ) {
        let updated_date = moment(toolDetails.lastUpdate.updatedData.date);
        let create_date = moment(toolDetails.createDate);
        if (updated_date.isAfter(create_date)) {
          updatedBy = (
            <div className="updated-by">
              Last update by
              <span>
                {updatedUserFirstName} {updatedUserLastName} on{" "}
                <div>{updated_date.format("MMMM Do, YYYY")}</div>
              </span>
            </div>
          );
          //  moment(toolDetails.lastUpdate.updatedData.date).format("MMMM Do, YYYY")
        }
      }
      // updatedBy = <span>{updatedUserFirstName} {updatedUserLastName} on <div>{moment (toolDetails.lastUpdate && toolDetails.lastUpdate.updatedData ? (toolDetails.lastUpdate.updatedData.date ? toolDetails.lastUpdate.updatedData.date : new Date()) : new Date()).format("MMMM Do, YYYY")}</div></span>
      // `${updatedUserFirstName} ${updatedUserLastName} on ${moment(toolDetails.lastUpdate && toolDetails.lastUpdate.updatedData ? (toolDetails.lastUpdate.updatedData.date ? toolDetails.lastUpdate.updatedData.date : new Date()) : new Date()).format("MMMM Do, YYYY")}`;
    } else {
      createdBy = "";
      updatedBy = "";
    }
    // else if(!toolDetails.isRecommendedByAdmin) {
    //   let createdUserFirstName = user ? (user.firstName ? user.firstName : "") : "";
    //   let createdUserLastName = user ? (user.lastName ? user.lastName : "") : "";
    //   createdBy = `${createdUserFirstName} ${createdUserLastName} on ${moment().format("MMMM Do, YYYY")}`;
    //   updatedBy = `${createdUserFirstName} ${createdUserLastName} on ${moment().format("MMMM Do, YYYY")}`;
    // }
    // }
    return (
      <div className="col-sm-12 pr0 d-flex mobile-flex-tool-detail-adjust">
        <div className="flex-shrink-1">{toolImage}</div>
        <div
          className="ml20 d-flex justify-content-between mobile-rating-tool"
          style={{ borderBottom: "1px solid #F06292", paddingBottom: "10px" }}
        >
          {/*name and created by update by*/}
          <div className="d-flex flex-column p_relative">
            <div className="d-flex flex-row align-content-around flex-wrap">
              <span className="d-flex">
                <span className="tool-name">
                  {toolDetails.name}
                  {privacy}
                  {recommendedTagView}
                  {archivedTagView}
                </span>
              </span>
            </div>

            {!toolDetails.isRecommendedByAdmin ? (
              <div style={{ marginTop: "7px" }}>
                <div className="created-by">Created by {createdBy}</div>
                {/* <div className="updated-by">
                    Last update by {updatedBy}
                  </div> */}
              </div>
            ) : null}

{!hideRatingsSection && (
            <div
              className={`toolDetailsRatingsContainer ${
                this.props.preview ? "opacity04 " : ""
              }`}
              style={{ minWidth: "165px" , position:'absolute', bottom:'0px'}}
            >
              <div className={`${!isMobile && "text-left"} mt10`}>
                {ratingOptions.map((rating, index) => {
                  if (rating <= avgRating)
                    return (
                      <img
                        key={index}
                        style={{
                          height: "18px",
                          marginLeft: index > 0 ? "7px" : "0px",
                        }}
                        src={star}
                      />
                    );
                  else
                    return (
                      <img
                        key={index}
                        style={{
                          height: "18px",
                          marginLeft: index > 0 ? "7px" : "0px",
                        }}
                        src={emptyStar}
                      />
                    );
                })}
              </div>
              <div className={`${!isMobile && "text-left"} mt10 rating-text inlineBlock`}>
                {toolRatings.length}{" "}
                {toolRatings.length > 1 ? "Ratings" : "Rating"}
              </div>
              <div className={`${!isMobile && "text-left"} mt10 inlineBlock`}>
                <Button
                  className="add-ratings-btn"
                  disabled={disableAddRating}
                  onClick={this.props.onAddRatingClick}
                >
                  <span className="add-rating-btn-txt">Add a Rating</span>
                </Button>
              </div>
            </div>
          )}
          </div>
          {/*End name and created by update by*/}
          {/* {!hideRatingsSection && (
            <div
              className={`toolDetailsRatingsContainer ${
                this.props.preview ? "opacity04 " : ""
              }`}
              style={{ minWidth: "165px" }}
            >
              <div className={`${!isMobile && "text-right"} mt10`}>
                {ratingOptions.map((rating, index) => {
                  if (rating <= avgRating)
                    return (
                      <img
                        key={index}
                        style={{
                          height: "18px",
                          marginLeft: index > 0 ? "7px" : "0px",
                        }}
                        src={star}
                      />
                    );
                  else
                    return (
                      <img
                        key={index}
                        style={{
                          height: "18px",
                          marginLeft: index > 0 ? "7px" : "0px",
                        }}
                        src={emptyStar}
                      />
                    );
                })}
              </div>
              <div className={`${!isMobile && "text-right"} mt10 rating-text`}>
                {toolRatings.length}{" "}
                {toolRatings.length > 1 ? "Ratings" : "Rating"}
              </div>
              <div className={`${!isMobile && "text-right"} mt10`}>
                <Button
                  className="add-ratings-btn"
                  disabled={disableAddRating}
                  onClick={this.props.onAddRatingClick}
                >
                  <span className="add-rating-btn-txt">Add a Rating</span>
                </Button>
              </div>
            </div>
          )} */}
        </div>
      </div>
    );
  }
}
